import {Grid, Tabs, Typography} from "@mui/material";
import {MobileContainer} from "../Global/Global";
import {zipToCity} from "../../Constants/Constants";
import React, {Fragment} from "react";
import {PostCardDynamic, PostCardDynamicSkeletons} from "../Posts/PostCard";
import Space from "../Common/Space";
import {useInstantSearch} from "react-instantsearch-hooks-web";
import {useSearchContext} from "../../Contexts/SearchContext";
import {Paginate} from "./SearchResults";
import {bannerStore} from "../../Stores/BannerStore";
import {Ad} from "../Ads/Ad";
import {FiltersMobile} from "./Filters/FiltersMobile/FiltersMobile";


// Function to render a single PostCardDynamic component
const renderPostCard = (post) => (
    <PostCardDynamic
        key={"search-results-mobile-" + post.objectID}
        postId={post.objectID}
        imageUrl={post.images[0].url}
        price={post.price}
        title={post.heading + ", " + post.body}
        subtitle={post.zip + " " + zipToCity["DK"][post.zip]}
        highlight={post.highlight}
    />
);

const Hits = () => {
    const searchContext = useSearchContext();
    const { status } = useInstantSearch()

    const hits = searchContext.data.hits ?? [];

    const banner = bannerStore.banners["M2"]
    const bannerRatio = "5/2"

    // If loading
    if (status == "loading" || status == "stalled") {
        return <PostCardDynamicSkeletons/>;
    }

    // If there were no results
    if (hits.length == 0 || status == "error") return (
        <MobileContainer>
            <Typography variant="h6">Ingen resultater</Typography>
            <Typography variant="h7">Prøv at søge på noget andet eller ændre i filtrene</Typography>
            <Space height="100px"/>
        </MobileContainer>
    )

    return <MobileContainer>
        <Grid container spacing={1}>
            {hits.map((post, index) => {
                return <Fragment key={"search-results-mobile-" + post.objectID}>
                    {/* At the 18th element we insert an ad */}
                    {index == 18 && (
                        <Grid item xs={12}>
                            <Ad
                                banner={banner}
                                aspectRatio={bannerRatio}
                            />
                            <Space height="15px"/>
                        </Grid>
                    )}
                    {renderPostCard(post)}
                </Fragment>
            })}
        </Grid>
    </MobileContainer>
}

export const SearchResultsMobile = () => {
    return (
        <React.Fragment>
            <FiltersMobile/>
            <Hits/>
            <Paginate/>
        </React.Fragment>
    );
}
